import React from 'react';
import { Link } from 'react-router-dom';
import { useWindowWidth } from '../hooks/useWindowWidth';
import { SUPPORT_EMAIL } from '../constants';
import { Logo } from './Logo';

const INK  = '#0A1F4A';
const INK2 = '#3D4F78';
const INK3 = '#7883A2';
const RULE = '#D6DAE4';
const BG   = '#ECEEF3';

const s = {
  footer: {
    borderTop: `1px solid ${RULE}`,
    background: BG,
    padding: '48px 0 32px',
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 24px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1.5fr 2fr',
    gap: 48,
    marginBottom: 40,
  },
  gridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 32,
    marginBottom: 32,
  },
  brand: {
    display: 'flex', alignItems: 'center', gap: 10,
    fontWeight: 700, fontSize: 18, color: INK,
    letterSpacing: '-0.02em', textDecoration: 'none',
    marginBottom: 12,
  },
  logoMark: {
    width: 26, height: 26,
    background: INK, borderRadius: 6,
    position: 'relative', overflow: 'hidden',
    flexShrink: 0,
  },
  brandTagline: {
    fontSize: 14,
    color: INK2,
    lineHeight: 1.6,
    maxWidth: 280,
  },
  cols: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 24,
  },
  colsMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
  },
  colTitle: {
    fontSize: 11,
    fontWeight: 500,
    color: INK3,
    textTransform: 'uppercase',
    letterSpacing: '0.14em',
    marginBottom: 12,
    fontFamily: '"JetBrains Mono", monospace',
  },
  colLink: {
    display: 'block',
    fontSize: 14,
    color: INK2,
    textDecoration: 'none',
    padding: '3px 0',
  },
  bottom: {
    borderTop: `1px solid ${RULE}`,
    paddingTop: 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
  },
  copy: {
    fontSize: 12,
    color: INK3,
    fontFamily: '"JetBrains Mono", monospace',
  },
};

export default function Footer() {
  const width = useWindowWidth();
  const isMobile = width < 640;

  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={isMobile ? s.gridMobile : s.grid}>
          <div>
            <Link to="/" style={s.brand}>
              <Logo tone="color" />
            </Link>
            <div style={s.brandTagline}>
              AI-powered EU tender discovery for European businesses. Built in Groningen, the Netherlands.
            </div>
          </div>

          <div style={isMobile ? s.colsMobile : s.cols}>
            <div>
              <div style={s.colTitle}>Product</div>
              <Link to="/dashboard" style={s.colLink}>Dashboard</Link>
              <Link to="/pricing"   style={s.colLink}>Pricing</Link>
              <Link to="/signup"    style={s.colLink}>Start free trial</Link>
            </div>

            <div>
              <div style={s.colTitle}>Resources</div>
              <Link to="/guide"                  style={s.colLink}>Tender Guide</Link>
              <Link to="/guide/what-is-a-tender" style={s.colLink}>What is a tender?</Link>
              <Link to="/guide/bidding-process"  style={s.colLink}>How to bid</Link>
              <Link to="/guide/glossary"         style={s.colLink}>Glossary</Link>
              <Link to="/blog"                   style={s.colLink}>Blog</Link>
            </div>

            <div>
              <div style={s.colTitle}>Company</div>
              <Link to="/about"     style={s.colLink}>About</Link>
              <Link to="/blog"      style={s.colLink}>Blog</Link>
              <a href={`mailto:${SUPPORT_EMAIL}`} style={s.colLink}>Contact</a>
            </div>

            <div>
              <div style={s.colTitle}>Legal</div>
              <Link to="/privacy" style={s.colLink}>Privacy policy</Link>
              <Link to="/terms"   style={s.colLink}>Terms of service</Link>
              <Link to="/gdpr"    style={s.colLink}>GDPR &amp; data</Link>
              <Link to="/cookies" style={s.colLink}>Cookie policy</Link>
            </div>
          </div>
        </div>

        <div style={s.bottom}>
          <span style={s.copy}>&copy; {new Date().getFullYear()} Jyto B.V.</span>
          <span style={s.copy}>GDPR compliant &mdash; EU data processing</span>
        </div>
      </div>
    </footer>
  );
}
